import { useSession } from '@side/next-auth/react';
import { useOptionalRouteParam } from '@/common/hooks/useOptionalRouteParam';
import { useUserInformation } from '@/common/hooks/useUserInformation/useUserInformation';
import { useCore } from '$api-clients/hooks';
import type { Template } from '../types';

type Props = {
  loadCreatedByData?: boolean;
};

export const useGetTemplateDetails = (options?: Props, skip?: boolean) => {
  const { loadCreatedByData = false } = options ?? {};
  const currentUserId = useSession().data?.user?.id;
  const interactionId = useOptionalRouteParam('templateId');

  const { isLoading, data, error } = useCore(
    '/users/{userId}/custom-templates/{interactionId}',
    currentUserId && interactionId && !skip
      ? {
          params: { path: { userId: currentUserId, interactionId } },
        }
      : null,
  );

  const createdByUser = useUserInformation(
    loadCreatedByData && !skip ? data?.createdBy : undefined,
  );

  const template: Template | null = data
    ? {
        ...data,
        appearsIn: data.appearsIn[0],
        isReadOnly: currentUserId !== data.owner,
        createdBy: createdByUser,
      }
    : null;

  return {
    template,
    loading: isLoading,
    error,
  };
};
